import React from 'react';
import {observer} from 'mobx-react';
import {Spinner} from 'shared/components';
import {Offer} from 'main/components';
import {FormattedMessage} from 'react-intl';
import {FullscreenModal, PreviewBanner} from 'shared/components/modals';

function bannerProps(offer) {
  if (offer.isExpired) {
    return {colour: 'bg-scarlet', text: 'components.offers.Viewing Expired Offer'};
  }
  if (offer.isAccepted) {
    return {colour: 'bg-grass', text: 'components.offers.Viewing Accepted Offer'};
  }
  if (offer.isRevoked) {
    return {colour: 'bg-scarlet', text: 'components.offers.Viewing Revoked Offer'};
  }

  return {colour: 'bg-meadow', text: 'components.offers.Previewing Candidate View'};
}

function hasEmployeeSignature(offer) {
  return offer.renderedContent && offer.renderedContent.includes('EMPLOYEE_SIGNATURE');
}

const OfferPreviewModal = observer(({offer, company, isOpen, onHide}) => {
  const banner = offer && bannerProps(offer);

  return (
    <FullscreenModal isOpen={isOpen}>
      {offer ?
        <React.Fragment>
          <PreviewBanner colour={banner.colour} onHide={onHide}>
            <FormattedMessage id={banner.text}/>
          </PreviewBanner>
          <Offer isPreview jobOffer={offer} logoUrl={company.logoUrl} signatureRequired={hasEmployeeSignature(offer)}/>
        </React.Fragment> :
        <Spinner/>}
    </FullscreenModal>
  );
});

export default OfferPreviewModal;
